import { Link } from 'react-router-dom';

const LOGO_URL =
  'https://static.readdy.ai/image/7064b84365a85e7f169350013ebfe335/cfa9cf550b39f15ff7c0c1dd12d033ba.png';

const SOCIAL_LINKS = [
  { icon: 'ri-instagram-line', label: 'Instagram', href: 'https://www.instagram.com/iamdirtybirdy' },
  { icon: 'ri-youtube-line', label: 'YouTube', href: 'https://www.youtube.com/channel/UC4Jwt8i6AWQ6WlKSvkRN25w' },
  { icon: 'ri-spotify-line', label: 'Spotify', href: 'https://open.spotify.com/artist/7wP0iHDhXO6uaLCgsEH76f?si=Fccs12UvSmKipUcqHK2nsA' },
  { icon: 'ri-tiktok-line', label: 'TikTok', href: 'https://www.tiktok.com/@dirtybirdy909' },
  { icon: 'ri-facebook-circle-line', label: 'Facebook', href: 'https://www.facebook.com/DirtyBirdy909/' },
];

const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Music', path: '/music' },
  { label: 'Store', path: '/store' },
  { label: 'Gallery', path: '/gallery' },
];

export default function Footer() {
  return (
    <footer className="bg-[#0D0D0D] border-t border-brand-yellow/20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 flex-shrink-0">
                <img
                  src={LOGO_URL}
                  alt="Dirty Birdy"
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="font-display text-2xl tracking-widest text-white">
                DIRTY BIRDY
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col gap-4">
            <h4 className="font-heading font-semibold text-brand-yellow tracking-widest uppercase text-sm">
              <a href="#navigation">Navigation</a>
            </h4>
            <ul className="flex flex-col gap-2">
              {NAV_LINKS.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="font-body text-white/60 hover:text-brand-orange transition-colors duration-200 text-sm cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Social & Contact */}
          <div className="flex flex-col gap-4">
            <h4 className="font-heading font-semibold text-brand-yellow tracking-widest uppercase text-sm">
              <a href="#connect">Connect</a>
            </h4>
            <div className="flex gap-3">
              {SOCIAL_LINKS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  rel="nofollow"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:border-brand-yellow hover:text-brand-yellow transition-all duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
            <p className="font-body text-white/50 text-sm mt-2">
              For bookings &amp; inquiries:<br />
              <strong className="text-brand-orange">tweettweetbookings@gmail.com</strong>
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="font-body text-white/30 text-xs">
            &copy; {new Date().getFullYear()} Dirty Birdy. All Rights Reserved.
          </p>
          <p className="font-body text-white/30 text-xs">
            West Coast Rap &bull; Inland Empire &bull; 909
          </p>
        </div>
      </div>
    </footer>
  );
}
